import { getDeepProperty } from '@/helpers/deepObject.js'
import * as types from './mutation-types.js'

const mutations = {
  [types.SET_AD_LIST] (state, ads) {
    state.ads = ads
  },
  [types.SET_CAN_CREATE_AD] (state, ad) {
    state.createAction = getDeepProperty(ad, 'create.action')
  }
}

export default mutations
